import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useTaskType, TaskType } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<TaskType>
      useData={useTaskType}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;

